import { render, staticRenderFns } from "./Nahrungsergaenzung.vue?vue&type=template&id=7c6c483c&"
import script from "./Nahrungsergaenzung.vue?vue&type=script&lang=js&"
export * from "./Nahrungsergaenzung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports